import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrandProvider} from '@context/BrandContext';
import {ContentProvider} from '@context/ContentContext';
import {UserProvider} from '@context/UserContext';
import {TemplateProvider} from "@common/context/TemplateContext";
import {ShortcutProvider} from "@common/context/ShortcutContext";
import {MessageDialogProvider} from '@context/MessageDialogContext';

import App from './App';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import {ChTheme} from '@common/MuiTheme';
import { ConfigProvider } from "antd";
import {SnackbarProvider} from 'notistack';
import {NavigationProvider} from "@common/context/NavigationContext";
import {ScreenModeProvider} from "@common/context/ScreenModeContext";

const rootElement = document.getElementById('root');
const shortcutId = rootElement.dataset.shortcutId;
const initSinglePage = rootElement.dataset.singlePage == 'true';
const antDTheme = {
    token: {
        colorTextDisabled: "rgba(0,0,0,0.55)",
        colorTextPlaceholder: "rgba(0,0,0,0.55)",
        colorTextDescription: "rgba(0,0,0,0.88)",
        colorLinkActive: "var(--on-button-colour)",
        colorBgSpotlight: "var(--tooltip-background)",
        fontFamily: "Open Sans",
    },
    components: {
        Input: {
            colorBorder: "var(--input-border-colour)",
            colorIcon: "var(--input-border-colour)",
            hoverBorderColor: "var(--input-colour)",
            activeBorderColor: "var(--input-colour)",
        },
        Button: {
            colorBorder: "var(--secondary-colour)",
            colorText: "var(--secondary-colour)",
            boxShadow: "none",
            boxShadowHover: "none",
            boxShadowActive: "none",
        },
        Select: {
            colorBorder: "var(--input-border-colour)",
            colorIcon: "var(--input-border-colour)",
            colorTextQuaternary: "var(--input-border-colour)",
            hoverBorderColor: "var(--input-colour)",
            activeBorderColor: "var(--focus-on-surface)",
            controlOutlineWidth: 1,
            controlOutline: "var(--focus-on-surface)",
            optionSelectedBg: "var(--input-colour)",
            optionSelectedColor: "var(--on-input-colour)",
        },
        Checkbox: {
            colorPrimary: "var(--input-colour)",
            colorBorder: "var(--input-border-colour)",
            hoverBorderColor: "var(--input-colour)",
            activeBorderColor: "var(--input-colour)",
        },
        Radio: {
            colorPrimary: "var(--input-colour)",
            colorBorder: "var(--input-border-colour)",
            hoverBorderColor: "var(--input-colour)",
            activeBorderColor: "var(--input-colour)"
        },
        DatePicker: {
            colorBorder: "var(--input-border-colour)",
            hoverBorderColor: "var(--input-colour)",
            activeBorderColor: "var(--input-colour)",
            colorIcon: "var(--input-border-colour)",
        },
        Table: {
            cellFontSizeSM: "1em",
            headerBg: "var(--table-border-colour)",
        },
        Statistic: {
            contentFontSize: "var(--main-font-size)",
        },
    },
    cssVar: {
        key: "ant"
    },
    hashed: false
}
window.buildVersion = process.env.BUILD_VERSION;

const root = createRoot(rootElement);
root.render(
    <ConfigProvider theme={antDTheme}>
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={ChTheme}>
            <BrandProvider>
                <ScreenModeProvider>
                    <ShortcutProvider>
                        <UserProvider>
                            <ContentProvider>
                                <MessageDialogProvider>
                                    <SnackbarProvider maxSnack={1} anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left'
                                    }}>
                                        <TemplateProvider shortcutId={shortcutId} initSinglePage={initSinglePage}>
                                            <NavigationProvider>
                                                <App/>
                                            </NavigationProvider>
                                        </TemplateProvider>
                                    </SnackbarProvider>
                                </MessageDialogProvider>
                            </ContentProvider>
                        </UserProvider>
                    </ShortcutProvider>
                </ScreenModeProvider>
            </BrandProvider>
        </ThemeProvider>
        </StyledEngineProvider>
    </ConfigProvider>
);